export default __webpack_public_path__ + "images/d1a73896c6641552876c5e5ecca9fb25-bushs_beans_tablet.webp";